import { MutationTree } from 'vuex'
import { UiState } from '@/store/ui'

export const mutations: MutationTree<UiState> = {

    minimizeNav(state: UiState): void {
        state.minimalizedNav = true
    },
    maximizeNav(state: UiState): void {
        state.minimalizedNav = false
    },
    toggleNav(state: UiState): void {
        state.minimalizedNav = !state.minimalizedNav
    },
    toggleCollapsableActive(state: UiState, payload: {active: boolean}): void {
        state.collapsableActive = payload.active
    },
}
